import { Link } from 'react-router-dom';
import "../pages-css/Home.css"
import img1 from '../assets/img/grid.png';


export default function Home() {
  return (
    <main className="container hero">
      <div className="row align-items-center g-5">
        
        {/* LEFT SIDE TEXT */}
        <div className="col-lg-6 text-center text-lg-start">
          <h1 className="display-4 fw-bold mb-3">Equivalents MGK</h1>
          <p className="lead tagline mb-4">
            Where wearable design meets technology. We're the UConn Senior Design team
            building customizable spirit-wear with NFT technology. Browse our Designs!
          </p>
          <Link to="/gallery" className="btn btn-primary btn-lg">
            Browse Designs
          </Link>
        </div>

        {/* RIGHT SIDE GRID + VIDEO */}
        <div className="col-lg-6 hero-image-wrap">
          <img className="hero-image" src={img1} alt="Hero product" />
        </div>

      </div>
    </main>
  );
}